<template>
  <div class="sp-template">
    <div class="h-title">{{title}}</div>
    <el-card class="box-card">
      <el-form :model="supplementAddData" size="small" class="new-costback__form" :label-width="formLabelWidth">
        <el-row>
          <el-col :span="10">
            <el-form-item label="补录类型" >
              <el-radio v-model="backType" label="1">按批次</el-radio>
              <el-radio v-model="backType" label="2">按订单</el-radio>
            </el-form-item>
            <span v-show="backType == '1'">
              <el-form-item label="批次号" >
                <el-input v-model.trim="supplementAddData.number" id="batchNumber" placeholder="批次号" @blur="queryBatchData"></el-input>
              </el-form-item>
              <el-form-item label="分摊类型" >
                <el-select v-model.lazy="supplementAddData.shareType">
                  <el-option v-for="(d, i) in shareTypeData" :key="i" :label="d.name" :value="d.code">{{d.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="目的地" >{{batchData.destination}}</el-form-item>
              <el-form-item label="发货日期" >{{batchData.shippingDate}}</el-form-item>
            </span>
            <span v-show="backType == '2'">
              <el-form-item label="订单号" >
                <el-input v-model.trim="supplementAddData.number" id="orderNumber" placeholder="订单号" @blur="queryOrderData"></el-input>
              </el-form-item>
              <el-form-item v-show="orderData && JSON.stringify(orderData) !== '{}'" label="客户名称" >{{orderData.orgOwner}}</el-form-item>
              <el-form-item v-show="orderData && JSON.stringify(orderData) !== '{}'" label="目的地" >{{orderData.destination}}</el-form-item>
              <el-form-item v-show="orderData && JSON.stringify(orderData) !== '{}'" label="发货日期" >{{orderData.shippingDate}}</el-form-item>
              <el-form-item v-show="orderData && JSON.stringify(orderData) !== '{}'" label="货物总箱数" >{{orderData.totalCarton}}</el-form-item>
              <el-form-item v-show="orderData && JSON.stringify(orderData) !== '{}'" label="总重量" >{{orderData.totalWeight}}</el-form-item>
              <el-form-item label="计费重量" >
                {{orderData.priceWeight == null ? "" : orderData.priceWeight - Math.floor(orderData.priceWeight) > 0.1 ? Math.ceil(orderData.priceWeight) : Math.floor(orderData.priceWeight)}}
              </el-form-item>
              <!-- <el-form-item label="基础费用" >{{orderData.cost}}</el-form-item> -->
            </span>
            <div class="sp-line"></div>
            <el-form-item label="费用科目" >
              <el-select v-model.lazy="supplementAddData.chargeSubject" filterable>
                <el-option v-for="(d, i) in chargeSubjectTypeData" :key="i" :label="d.name" :value="d.name">{{d.name}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费用分类" >
              <el-select v-if="backType == '1'" v-model.lazy="supplementAddData.chargeType" @change="querySupplier(supplementAddData.chargeType)">
                <el-option v-for="(d, i) in chargeTypeDataBatch" :key="i" :label="d.name" :value="d.code">{{d.name}}</el-option>
              </el-select>
              <el-select v-else v-model.lazy="supplementAddData.chargeType" @change="querySupplier(supplementAddData.chargeType)">
                <el-option v-for="(d, i) in chargeTypeData" :key="i" :label="d.name" :value="d.code">{{d.name}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="supplementAddData.chargeType == 'finance_payment'" label="供应商" >
              <el-select v-model.lazy="supplementAddData.supplierId">
                <el-option v-for="(d, i) in suppliers" :key="i" :label="d.name" :value="d.id">{{d.name}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="补录类型" >
              <el-select v-model.lazy="supplementAddData.supplementType">
                <el-option v-for="(d, i) in supplementTypeData" :key="i" :label="d.name" :value="d.code">{{d.name}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="补录币种" >
              <el-select name="currency" v-model="supplementAddData.currency">
                <el-option v-for="currency in currencies" :label="currency.name" :value="currency.value" :key="currency.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="补录金额" >
              <el-input type="number" v-model.lazy="supplementAddData.amount" placeholder="补录金额">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
            <el-form-item label="备注" >
              <el-input type="textarea" v-model="supplementAddData.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top: 50px;">
          <el-button size="small" @click="back">返 回</el-button>
          <el-button size="small" type="primary" @click="handlerSave">保 存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      backType: "1",
      supplementAddData: {
        number: "",
        shareType: "charge_weight",
        chargeSubject: "",
        chargeType: "receipt",
        supplementType: "cut_payment",
        currency: "CNY",
        amount: 0,
        remarks: "",
        supplierId: ""
      },
      currencies: [
        // { name: "美元", value: "USD" },
        // { name: "欧元", value: "EUR" },
        { name: "人民币", value: "CNY" }
        // { name: "港币", value: "HKD" },
        // { name: "日元", value: "JPY" }
      ],
      orderData: {},
      batchData: { destination: "", shippingDate: "" },
      //  分摊类型
      shareTypeData: [],
      shareTypeDataMaps: {},

      //费用分类
      chargeTypeData: [],
      chargeTypeDataBatch: [],
      chargeTypeDataMaps: {},
      //补录类型
      supplementTypeData: [],
      supplementTypeDataMaps: {},
      //费用科目
      chargeSubjectTypeData: [],
      chargeSubjectTypeDataMaps: {},
      formLabelWidth: "120px",
      suppliers: []
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.initData();
    }, 1000);
  },
  computed: {
    title() {
      return this.$route.query.ishandler ? "编辑费用补录" : "新建费用补录";
    }
  },
  methods: {
    initData() {
      let _this = this;
      let urlArray = [
        this.findAllShareType(),
        this.findAllSupplementType(),
        this.findAllChargeType(),
        this.findAllChargeSubjectType()
      ]; // unknown # of urls (1 or more)

      this.$axios.all(urlArray).then(
        this.$axios.spread(function(
          shareTypeData,
          supplementTypeData,
          chargeTypeData,
          chargeSubjectTypeData
        ) {
          _this.initShareType(shareTypeData);
          _this.initSupplementType(supplementTypeData);
          _this.initChargeType(chargeTypeData);
          _this.initChargeSubjectType(chargeSubjectTypeData);
        })
      );
    },
    initShareType(data) {
      let _this = this;
      _this.shareTypeData = data.data;
      if (_this.shareTypeData.length > 0) {
        _this.shareTypeData.forEach(c => {
          _this.shareTypeDataMaps[c.code] = c.name;
        });
      }
    },
    findAllShareType() {
      return this.$request1.get(
        '/supplement/share-type'
      );
    },
    initSupplementType(data) {
      let _this = this;
      _this.supplementTypeData = data.data;
      if (_this.supplementTypeData.length > 0) {
        _this.supplementTypeData.forEach(c => {
          _this.supplementTypeDataMaps[c.code] = c.name;
        });
      }
    },
    findAllSupplementType() {
      return this.$request1.get(
        '/supplement/supplement-type'
      );
    },

    initChargeType(data) {
      let _this = this;
      _this.chargeTypeData = data.data;
      _this.chargeTypeDataBatch = [{"code": "finance_payment","name": "财务成本"}];
      if (_this.chargeTypeData.length > 0) {
        _this.chargeTypeData.forEach(c => {
          _this.chargeTypeDataMaps[c.code] = c.name;
        });
      }
    },
    findAllChargeType() {
      return this.$request1.get(
        '/supplement/charge-type'
      );
    },

    initChargeSubjectType(data) {
      let _this = this;
      _this.chargeSubjectTypeData = data.data;
      if (_this.chargeSubjectTypeData.length > 0) {
        _this.chargeSubjectTypeData.forEach(c => {
          _this.chargeSubjectTypeDataMaps[c.code] = c.name;
        });
      }
    },
    findAllChargeSubjectType() {
      return this.$request1.get(
        '/system/map/charge-subject'
      );
    },

    //查询订单信息
    queryOrderData() {
      let number = this.supplementAddData.number;
      if (number.trim() == "") {
        return;
      }
      this.$request1({
        method: 'GET',
        url: '/supplement/' + number + '/order-info'
      })
        .then(response => {
          console.log(response);
          if (response.data.success) {
            this.orderData = response.data.data;
          } else {
            this.supplementAddData.number = "";

            this.orderData = {};
            document.getElementById("orderNumber").focus();
            this.$notify.error({
              title: "错误",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //查询批次信息
    queryBatchData() {
      let number = this.supplementAddData.number;
      if (number.trim() == "") {
        return;
      }
      this.$request1({
        method: 'GET',
        url: '/supplement/' + number + '/batch-info'
      })
        .then(response => {
          console.log(response);
          if (response.data.success) {
            this.batchData = response.data.data;
          } else {
            this.supplementAddData.number = "";
            this.batchData = {};
            document.getElementById("batchNumber").focus();
            this.$notify.error({
              title: "错误",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    back() {
      this.$router.go(-1);
    },
    handlerSave() {
      //validate
      //按照批次
      if (this.backType == "1") {
        if (this.supplementAddData.shareType == "") {
          this.$message.error("请选择分摊类型");
          return;
        }
      } else {
        //按照订单
        this.supplementAddData.shareType = "";
        this.supplementAddData.orgOwnerId = this.orderData.orgOwnerId;
      }
      if (this.supplementAddData.chargeSubject == "") {
        this.$message.error("请选择费用科目");
        return;
      }
      if (this.supplementAddData.chargeType == "") {
        this.$message.error("请选择费用分类");
        return;
      } else if (this.supplementAddData.chargeType == "finance_payment") {
        if (this.supplementAddData.supplierId == "") {
          this.$message.error("请选择供应商");
          return;
        }
      }
      if (this.supplementAddData.supplementType == "") {
        this.$message.error("请选择补录类型");
        return;
      }
      if (this.supplementAddData.currency == "") {
        this.$message.error("请选择币种");
        return;
      }
      if (this.supplementAddData.amount == "") {
        this.$message.error("请输入补录金额");
        return;
      }
      if (
        this.supplementAddData.amount !== "" &&
        new Number(this.supplementAddData.amount) <= 0
      ) {
        this.$message.error("请输入数字值，且不能是负数或零");
        return;
      }

      let info = `是否确认订单${this.supplementAddData.number}补录￥${this.supplementAddData.amount}?`;
      this.$confirm(info, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.supplementAddData.amount = new Number(
          this.supplementAddData.amount
        ).toFixed(2);
        this.$request1({
          method: 'POST',
          url: '/supplement',
          data: this.supplementAddData
        })
          .then(response => {
            if (response.data.success) {
              this.$message({
                type: "success",
                message: "保存成功!"
              });
              this.$router.push({
                path: "/orderOperation/chargesupplement"
              });
            } else {
              this.$notify.error({
                title: "错误",
                message: response.data.message
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    toFixed(num, len) {
      if (!num || isNaN(num)) {
        return "";
      }
      var times = Math.pow(10, len);
      var des = num * times + 0.5;
      return parseInt(des, 10) / times;
    },
    // 供应商名称
    querySupplier(chargeType) {
      if (chargeType == "finance_payment") {
        this.$request1({
          method: 'GET',
          url: '/supplier'
        })
          .then(response => {
            this.suppliers = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.suppliers = [];
        this.supplementAddData.supplierId = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/orderOperation/newcostback.vue